import React from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import breakpoints from "../../styles/breakpoints"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { withTranslation, Trans } from "gatsby-plugin-react-i18next"
import { getCurrentEnvironment } from "../../services/environmentHelper"

const StyledContainer = styled.div`
  background: ${colors.white};
  border-top: 1px solid ${colors.newBorderGrey};
  border-bottom: 1px solid ${colors.newBorderGrey};
  padding: 16px 26px;

  @media (min-width: ${breakpoints.md}) {
    padding: 26px 34px;
  }
`

const Title = styled.div`
  ${fonts.selfModern};
  font-size: 14px;
  line-height: 1.36;
  margin-bottom: 14px;
  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 20px;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 126px 1fr;
  gap: 28px;
`

const Content = styled.div`
  ${fonts.helveticaNeue};
  padding: 12px 0;
`

const ContentTitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`

const TitleContent = styled.div`
  ${fonts.helveticaNeueMedium};
  font-weight: 500;
  font-size: 12px;
  line-height: 1.58;
  color: ${(props) => (props.price ? colors.green : colors.black)};
`

const ContentCopy = styled.div`
  p {
    margin-bottom: 14px;
    color: ${colors.newMediumGrey};
    font-size: 10px;
    line-height: 1.4;
  }
`

const BlackFriday = ({ t }) => {
  const { card } = useStaticQuery(graphql`
    query BlackFridayQuery {
      card: file(relativePath: { eq: "blackfriday/gift-card-2022.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 126)
        }
      }
    }
  `)

  const environment = getCurrentEnvironment()

  let currencySign = "$"
  if (environment === "uk") {
    currencySign = "£"
  } else if (environment === "eu" || environment === "fr") {
    currencySign = "€"
  }

  return (
    <StyledContainer>
      <Title>
        <Trans i18nKey="minicart.blackfriday.title">
          You get a {currencySign}100 gift card
        </Trans>
      </Title>
      <Grid>
        <GatsbyImage
          image={card.childImageSharp.gatsbyImageData}
          alt="Gift card"
        />
        <Content>
          <ContentTitleSection>
            <TitleContent>{t("minicart.blackfriday.card_title")}</TitleContent>
            <TitleContent price>
              {t("minicart.blackfriday.card_price")}
            </TitleContent>
          </ContentTitleSection>
          <ContentCopy>
            <Trans i18nKey={"minicart.blackfriday.card_content"}>
              <p>
                To make your orders extra festive this year, each will come with
                a {currencySign}100 gift card for you to give to a friend.
              </p>
              <p>Happy holidays!</p>
            </Trans>
          </ContentCopy>
        </Content>
      </Grid>
    </StyledContainer>
  )
}

export default withTranslation()(BlackFriday)
